<template>
  <div class="container">
    <div class="d-flex justify-content-end">
      <div class="btn-home mt-3 mb-4">
        <button type="button" class="btn btn-outline-main" @click="returnHome">
          <i class="fas fa-home-lg-alt"></i> Inicio
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="card w-100 mb-lg-5">
        <div class="text-center card-header text-white h4 bg-main">
          <strong>PLANES</strong>
        </div>
        <div class="card-body w-100">
          <div class="row mt-3 px-3">
            <div class="col-xl-3">
              <div class="input-group input-group-sm">
                <span
                  class="input-group-text text-white bg-main cursor-pointer"
                >
                  <i class="fas fa-calendar"></i>&nbsp;&nbsp;
                </span>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="date"
                  :max="hoy"
                  @change="mtdGetData"
                />
              </div>
            </div>
            <div class="col-xl-5">
              <div class="input-group input-group-sm">
                <span
                  class="input-group-text text-white bg-main cursor-pointer"
                >
                  <i class="fas fa-search"></i>&nbsp;&nbsp;Filtrar
                </span>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Buscar DNI o nombre de Paciente o tipo de documento"
                  v-model="search"
                  @keyup="calculateData(10)"
                />
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 text-center px-0">
              <!-- paginado -->
              <div v-if="cpData.length > 0" class="d-flex justify-content-end">
                <nav aria-label="Page navigation example">
                  <ul class="pagination mb-1">
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="backPage"
                        >Anterior</a
                      >
                    </li>
                    <li v-if="limitedStepPagination[0] != 1" class="page-item">
                      <a
                        :class="
                          selectPage == 1 ? 'page-link active' : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(1)"
                        >1</a
                      >
                    </li>
                    <li
                      v-if="limitedStepPagination[0] > 2"
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-for="(item, index) in limitedStepPagination"
                      :key="index"
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage == item ? 'page-link active' : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(item)"
                        >{{ item }}
                      </a>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[
                          limitedStepPagination.length - 1
                        ] <
                        stepPagination.length - 1
                      "
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>
                    <li
                      v-if="
                        limitedStepPagination[
                          limitedStepPagination.length - 1
                        ] != stepPagination.length
                      "
                      class="page-item"
                    >
                      <a
                        :class="
                          selectPage == limitedStepPagination.length + 2
                            ? 'page-link active'
                            : 'page-link'
                        "
                        href="javascript:void(0)"
                        @click="selectedPage(stepPagination.length)"
                        >{{ stepPagination.length }}
                      </a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link page"
                        href="javascript:void(0)"
                        @click="nextPage"
                        >Siguiente</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="col-md-12 mt-1 px-0" id="content-timelinetable">
              <table id="tb-anular" class="table table-bordered border-main">
                <caption class="py-0 my-0"></caption>
                <thead>
                  <tr class="table-th text-white text-center text-xs">
                    <th scope="col">N°</th>
                    <th scope="col">ORIGEN</th>
                    <th scope="col">LABORATORIO</th>
                    <th scope="col">PACIENTE</th>
                    <th scope="col">FECHA DE SOLICITUD</th>
                    <th scope="col">MÉDICO SOLICITA</th>
                    <!-- <th scope="col">PLAN</th> -->
                    <th scope="col" colspan="1">ACCIONES</th>
                    <!-- <th scope="col" v-if="cpShowColumn">AGRUPAR</th> -->
                  </tr>
                </thead>
                <tbody class="text-xs">
                  <tr class="table-body text-center" v-if="cpData.length == 0">
                    <td colspan="8">No se han encontrado resultados</td>
                  </tr>
                  <tr
                    class="table-body text-center"
                    v-for="(item, index) in cpData"
                    :key="index"
                    v-else
                  >
                    <td>{{ index + 1 }}</td>
                    <td class="align-left">
                      {{
                        item.type_service == 1
                          ? "CONSULTA"
                          : item.type_service == 3
                          ? "HOSPITALIZACIÓN"
                          : item.type_service == 4
                          ? "UCI ADULTO"
                          : "EMERGENCIA"
                      }}
                    </td>
                    <td>
                      {{
                        item.laboratorie_id == null
                          ? "SIN ASIGNAR"
                          : item.laboratorie.name
                      }}
                    </td>
                    <td>{{ item.patient_name }}</td>
                    <!-- <td>{{ item.subsubcategorie.name }}</td> -->
                    <td class="align-center">
                      {{ item.date_created | formatDate }}
                    </td>
                    <td class="align-center">
                      {{ item.doctor_name }} {{ item.doctor_last_name }}
                    </td>
                    <!-- <td class="align-center">
                      <span v-if="item.type == 1">LABORATORIO</span>
                      <span v-if="item.type == 2"> IMAGENES</span>
                      <span v-if="item.type == 3"> PROCEDIMIENTOS</span>
                    </td> -->
                    <td v-if="item.file" class="text-center align-middle">
                      <div class="d-flex justify-content-center">
                        <button
                          class="btn btn-sm btn-danger text-white"
                          @click="openPdf(item.file)"
                        >
                          <i class="fa fa-file-pdf"></i>
                        </button>
                      </div>
                    </td>
                    <td v-else class="text-center align-middle">
                      <div class="d-flex justify-content-center">
                        <!-- <button
                          @click="triggerFileInput(index)"
                          :disabled="mtdDisableButton(item)"
                          class="btn btn-sm btn-warning text-white"
                        >
                          <i class="fas fa-upload"></i>
                        </button>
                        <input
                          type="file"
                          @change="handleFileUpload($event, index, item)"
                          :ref="'fileInput' + index"
                          style="display: none"
                        /> -->
                        <button
                          @click="mtdSetResult(item)"
                          :disabled="mtdDisableButton(item)"
                          class="btn btn-sm btn-warning text-white"
                          v-if="item.laboratorie_id == null"
                        >
                          <i class="fas fa-upload"></i>
                        </button>
                        <button
                          @click="mtdViewResult(item)"
                          class="btn btn-sm btn-success text-white"
                          v-else
                        >
                          <i class="fas fa-file-pdf"></i>
                        </button>
                        &nbsp;
                        <button
                          v-if="item.laboratorie_id == null"
                          @click="mtdSelectLaboratory(item)"
                          class="btn btn-sm btn-info text-dark"
                        >
                          <i class="fas fa-recycle"></i>
                        </button>
                        &nbsp;
                        <button
                          @click="mtdPrint(item)"
                          class="btn btn-sm btn-primary text-white"
                        >
                          <i class="fas fa-print"></i>
                        </button>
                      </div>
                    </td>
                    <!-- check para subir un solo archivo -->
                    <!--<td scope="row" class="align-center" v-if="cpShowColumn">
                      <div v-if="!item.file">
                        <input
                          class="form-check-input mt-1"
                          type="checkbox"
                          aria-label="Checkbox for following text input"
                          v-model="item.uploadGroup"
                        />
                      </div>
                    </td>
                    -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cModalSetResultsVue
      :payload="modalItem.payload"
      :title="modalItem.title"
      :boo_modal="modalItem.modal_form"
      @closeModal="closeModalSetResult"
      @mtdSave="mtdSave"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import cModalSetResultsVue from '../modals/cModalSetResults.vue';

export default {
  name: "c-admision-Planes",
  components:{cModalSetResultsVue},
  data() {
    return {
      dataplanes: [],
      dataLabs:[],
      date: null,
      hoy: null,
      search: "",
      totalPagesToShow: 4,
      page: 0,
      selectPage: 1,
      stepPagination: [],
      dataShow: [],
      pos: 0,
      pos2: true,
      selected: false,
      modalItem:{
        title: "",
        modal_form: false,
        payload: {
          detail:[]
        },
      }
    };
  },
  computed: {
    cpData() {
      return this.dataShow;
    },
    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;

      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;

          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }

      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
    cpShowColumn() {
      const elementsWithNullFile = this.dataplanes.filter(
        (element) => element.file == null
      );

      if (elementsWithNullFile.length > 1) {
        return this.dataplanes.some((element) => element.file == null);
      } else {
        return false;
      }
    },
  },
  watch: {
    selectPage() {
      this.calculateData(10);
    },
  },
  created() {
   
    const currentDate = new Date();
    const today = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    this.date = today.toISOString().split("T")[0];
    this.hoy = this.date;
    this.mtdGetData();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome: function () {
      this.$emit("changePage", "home");
    },
    mtdGetData: function () {
      this.post({
        url: this.$store.getters.get__url + "/laboratory/planes",
        token: this.$store.getters.get__token,
        params: {
          date: this.date,
        },
      })
        .then((response) => {
          this.dataplanes = response.data.data;
          this.dataplanes = this.dataplanes.map((item) => ({
            ...item,
            uploadGroup: false,
          }));
          console.log(this.dataplanes);
          this.pos = 1;
          this.pos2 = false;
          this.dataLabs= response.data.laboratories;
          this.calculateData(10);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    calculateData(items) {
      if (!this.dataplanes) {
        this.dataShow = [];
      }
      let filteredData = this.dataplanes;
      if (this.search.trim().length > 0) {
        let ss = this.search.toString().toUpperCase();
        filteredData = filteredData.filter((item) =>
          item.medicalact.patient.name.includes(ss)
        );
      }
      let selectPage = this.selectPage;
      let totalPages = Math.ceil(filteredData.length / items);
      this.stepPagination = Array.from(
        {
          length: totalPages,
        },
        (_, index) => index + 1
      );
      let startIndex = (selectPage - 1) * items;
      let endIndex = startIndex + (items - 1);
      this.dataShow = filteredData.slice(startIndex, endIndex + 1);
    },
    mtdDisableButton: function (item) {
      let group = this.dataplanes.some(
        (element) => element.uploadGroup == true
      );
      if (group == true) {
        //esta en grupo
        return item.uploadGroup == false;
      } else {
        return false;
      }
    },
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    triggerFileInput(index) {
      this.$refs["fileInput" + index][0].click();
    },
    handleFileUpload(event, index, item) {
      let file = event.target.files[0];
      let allowedExtensions = /\.(png|jpg|jpeg|pdf)$/i;

      if (!allowedExtensions.test(file.name)) {
        let fileType = "imagen o PDF";
        Swal.fire({
          text: `Seleccione un archivo formato ${fileType}`,
          icon: "info",
          confirmButtonColor: "#900052",
        }).then((result) => {
          if (result.isConfirmed) {
            const input = this.$refs["fileInput" + index][0];
            input.type = "text";
            input.type = "file";
          }
        });
      } else {
        this.filelaboratorio = file;
        let formData = new FormData();

        let group = this.dataplanes.some(
          (element) => element.uploadGroup == true
        );
        //let uploadGroup = group == true ? 1 : 0 ;
        let filteredData = [];
        if (group == true) {
          this.dataplanes.forEach((element) => {
            if (element.uploadGroup == true) {
              filteredData.push(element.id);
            }
          });
        } else {
          filteredData.push(item.id);
        }

        formData.append("id", item.id);
        formData.append("ids", filteredData);
        formData.append("file", this.filelaboratorio);
        formData.append("document", item.medicalact.patient.document);
        formData.append("case", 1);
        this.post({
          url:
            this.$store.getters.get__url + "/laboratory/editHistoryPlanDetail",
          token: this.$store.getters.get__token,
          params: formData,
        })
          .then((response) => {
            if (response.statusCode == 200) {
              Swal.fire({
                icon: "success",
                title: "Datos Guardados",
                showConfirmButton: false,
                timer: 1500,
              });
              this.mtdGetData();
            }
          })
          .catch((errors) => {});
      }
    },
    openPdf: function (url) {
      let nuevaUrl = "/assets/" + url;
      window.open(nuevaUrl, "_blank");
    },
    /* retroceder o volver al inicio */
    mtdChangeView: function (option) {
      this.$emit("mtdChangePage", option);
    },
    /** editar laboratorio */
    mtdSelectLaboratory: function (item) {
      Swal.fire({
        title: "Seleccione una opción",
        html: `
          <div id="btn-container" style="display:flex; gap:10px; flex-wrap:wrap;">
            ${this.dataLabs
              .map(
                (item) => `
              <button 
                class="btn-item"
                data-id="${item.id}"
                style="
                  padding:8px 14px;
                  border:1px solid #3085d6;
                  background:#fff;
                  color:#3085d6;
                  border-radius:5px;
                  cursor:pointer;
                ">
                ${item.name}
              </button>
            `
              )
              .join("")}
          </div>
        `,
        showConfirmButton: true,
        confirmButtonText: "Aceptar",
        didOpen: () => {
          let selectedItem = null;

          document.querySelectorAll(".btn-item").forEach((btn) => {
            btn.addEventListener("click", () => {
              // resetear estilos
              document.querySelectorAll(".btn-item").forEach((b) => {
                b.style.background = "#fff";
                b.style.color = "#3085d6";
              });

              // marcar seleccionado
              btn.style.background = "#3085d6";
              btn.style.color = "#fff";

              selectedItem = btn.dataset.id;
            });
          });

          // guardar selección en Swal
          Swal.getConfirmButton().addEventListener("click", () => {
            if (!selectedItem) {
              Swal.showValidationMessage("Debe seleccionar una opción");
              return;
            }
            Swal.close();
            this.mtdCommitLab(item.id, selectedItem);
          });
        },
      });
    },
    mtdCommitLab: function(id, value){
      this.post({
        url: this.$store.getters.get__url + "/laboratory/commiteditplan",
        token: this.$store.getters.get__token,
        params: {
          id: id,
          lab: value,
        },
      })
        .then((response) => {
          this.mtdGetData();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    /** print */
    mtdPrint: function(payload){
      let create = payload.date_created.replace(" ","_");
      window.open(this.$store.getters.get__url+"/plan/pdf/"+create+"/1");
    },
    mtdSetResult: function(payload){
      console.log(payload);
      this.modalItem.title = "REGISTRAR RESULTADOS";
      this.modalItem.payload=payload;
      this.modalItem.modal_form=true;
    },
    closeModalSetResult: function(){
      this.modalItem.title = "REGISTRAR RESULTADOS";
      this.modalItem.payload={};
      this.modalItem.modal_form=false;
    },
    mtdSave: function(payload){
      this.post({
        url: this.$store.getters.get__url + "/laboratory/setresultplan",
        token: this.$store.getters.get__token,
        params: {
          plan_id: this.modalItem.payload.plan_id,
          result: payload,
          url: this.$store.getters.get__url
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            window.open(this.$store.getters.get__url+"/laboratory/results/"+response.data.uuid);
            Swal.fire({
              icon: "success",
              title: "Registrado correctamente",
              showConfirmButton: false,
            });
            this.close
            this.mtdGetData();
            this.modalItem.title = "REGISTRAR RESULTADOS";
            this.modalItem.modal_form=false;
          }else{
            console.error(response.data);
            Swal.fire({
              icon: "warning",
              title: "Ocurrió un error inesperado",
              showConfirmButton: false
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdViewResult: function(payload){
      window.open(this.$store.getters.get__url+"/laboratory/results/"+payload.uuid);
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return "";

      const date = new Date(value.replace(" ", "T"));

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    },
  },
};
</script>
